import { AccountType } from 'src/models';

import { Maybe } from './types.utils';

export const getAccountHolderSubheader = ({
  type,
  isPrimary = false,
  authorizedSigner,
}: {
  type?: AccountType;
  isPrimary?: boolean;
  authorizedSigner?: number;
}): Maybe<string> => {
  if (isPrimary && (type?.isJoint || type?.isUgma)) {
    return 'Primary Account Holder';
  }

  if (type?.isJoint) {
    return 'Joint Account Holder';
  }

  if (type?.isUgma) {
    return 'UGMA Beneficiary';
  }

  if (isPrimary && type?.isEntity) {
    return 'Authorized Signer 1';
  }

  if (type?.isEntity && authorizedSigner) {
    return `Authorized Signer ${authorizedSigner}`;
  }
};
